import { useId, type ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface HelpTooltipProps {
  children: ReactNode
  className?: string
  label: string
  widthClassName?: string
}

export function HelpTooltip({
  children,
  className,
  label,
  widthClassName = 'w-[240px]',
}: HelpTooltipProps) {
  const tooltipId = useId()

  if (!label.trim()) {
    return null
  }

  return (
    <span className={cn('group relative inline-flex', className)}>
      <span
        aria-describedby={tooltipId}
        aria-label={label}
        className="inline-flex size-4 cursor-help items-center justify-center rounded-full border border-[rgba(26,28,25,0.18)] text-[11px] leading-none text-[var(--color-text-muted)] outline-none transition-colors hover:border-[rgba(26,28,25,0.32)] hover:text-[var(--color-text)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus)]"
        tabIndex={0}
      >
        ?
      </span>
      <span
        className={cn(
          'pointer-events-none absolute top-1/2 left-full z-[110] ml-2 hidden -translate-y-1/2 rounded-md bg-[#1f2937] px-2.5 py-1.5 text-xs leading-5 font-normal text-white shadow-[0_10px_24px_rgba(15,23,42,0.18)] group-hover:block group-focus-within:block',
          widthClassName,
        )}
        id={tooltipId}
        role="tooltip"
      >
        {children}
      </span>
    </span>
  )
}
